import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { Router } from '@angular/router';
import { CommonService } from "./shared/common.service";
import { Site } from './study.model';
import { EnvironmentConfigService } from './shared/environment-config.service';

import { map } from 'rxjs/operators';
import { Template } from './study.model';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private apiUrl: string;
  url: string;

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private commonService: CommonService,
    private router: Router,
    private envConfig: EnvironmentConfigService
  ) {
    // Initialize URLs from environment config service
    this.apiUrl = this.envConfig.getApiUrl();
    this.url = this.envConfig.getBaseUrl();
  }

  getUser(userId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/viewuser/${userId}`).pipe(
      catchError((error) => this.handleError(error))  // Handle errors properly
    );
  }
  
  login(email: string, password: string, purpose: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/login`, {email, password, purpose}).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  updatePassword(email: string, password: string): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/update-password`, { email, password }).pipe(
      catchError((error) => this.handleError(error))
    )
  }

   // Update user details by ID
   updateUser(userId: string, userData: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/api/user/${userId}`, userData).pipe(
      catchError((error) => this.handleError(error))
    );
  }


  get<T>(url: string, params?: HttpParams, headers?: HttpHeaders): Observable<T> {
    headers = this.buildHeaders(headers);
    return this.http.get<T>(`${this.url}/${url}`, { params, headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  getAllStudiesWithCRC(userId: string, page: number, limit: number, study_name: string, assigned_by: string, is_active: string, status: string, designation: string): Observable<any> {
    const params = new HttpParams()
      .set('userId', userId)
      .set('page', page.toString())
      .set('limit', limit.toString())
      .set('study_name', study_name)
      .set('assigned_by', assigned_by)
      .set('is_active', is_active)
      .set('status', status)
      .set('designation', designation);

    return this.http.get(`${this.apiUrl}/api/getAllStudiesWithCRC`, { params });
  }

  // Assign CRCs to study
  assignCRCs(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/assignCRCs`, data).pipe(
      catchError((error) => this.handleError(error))
    );
  }

deleteStudy(id: number) {
  return this.http.delete(`${this.apiUrl}/api/studies/${id}`);
}

  
  post<T>(url: string, body?: any, headers?: HttpHeaders): Observable<any> {
    headers = this.buildHeaders(headers);
    let options = { headers: headers};
    return this.http.post(`${this.apiUrl}/${url}`, body, options).pipe(
      catchError((error) => this.handleError(error))
    );
  }

   



   // DELETE method implementation
   delete<T>(url: string, body?: any, headers?: HttpHeaders): Observable<T> {
    headers = this.buildHeaders(headers); // Optional: Build headers if needed
    const options = { headers, body }; // Include body if needed

    return this.http.delete<T>(`${this.url}/${url}`, options).pipe(
      catchError((error) => this.handleError(error)) // Handle errors
    );
  }



  // Add a user to the same URL
  addUser(user: any): Observable<any> {
    // Use the correct base URL and endpoint
    return this.http.post(`${this.apiUrl}/api/adduser`, user).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Add access
  addAccess(access: any): Observable<any> {
    // Use the correct base URL and endpoint
    return this.http.post(`${this.apiUrl}/api/addaccess`, access).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Get access list
  getAccessList(): Observable<any> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get(`${this.apiUrl}/api/getAccessList`, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // view-study api 
  // getData(id = 1): Observable<any> {
  //   return this.http.get<any>(`${this.apiUrl}/api/getStudyCrcDetail/${id}`).pipe(
  //     catchError((error) => this.handleError(error))
  //   );
  // }

  // createStudy(studyData: any): Observable<any> {
  //   return this.http.post(`${this.apiUrl}/api/createStudy`, studyData);
  // }

  // updateStudy(studyData: any, id: Number): Observable<any> {
  //   return this.http.post(`${this.apiUrl}/api/updateStudy/${id}`, studyData);
  // }

  // deactivateStudy(id, is_active): Observable<any> {
  //   return this.http.post(`${this.apiUrl}/api/deactivateStudy/${id}`, { "is_active": Number(is_active) }).pipe(
  //     catchError((error) => this.handleError(error))
  //   );
  // }

   // Fetch user list from the same URL

   getUserList(page: number,limit: number,  name: string = '', site_location: string = '', designation: string = '', status: string = '', userId: any): Observable<any> {
    const token = this.cookieService.get('token'); // Get the token from cookies
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    
    // Append filters to the query string
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      name,
      site_location,
      designation,
      status,
      userId
    }).toString();
    
    return this.http.get(`${this.url}/api/userlist?${queryParams}`, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  getRegisteredUserList(page: number,limit: number,  name: string = '', site_location: string = '', designation: string = '', status: string = '', userId: any): Observable<any> {
    const token = this.cookieService.get('token'); // Get the token from cookies
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    
    // Append filters to the query string
    const queryParams = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
      name,
      site_location,
      designation,
      status,
      userId
    }).toString();
    
    return this.http.get(`${this.url}/api/registereduserlist?${queryParams}`, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }






// // createStudy(name: string, code: string, crcs_list: string[]): Observable<any> {
//   createStudy(studyData): Observable<any> {
//   const payload = {
//     name: name,
//     code: code,
//     crcs_list: crcs_list
//   };

//   return this.http.post(`${this.apiUrl}/api/studies`, payload);
// }


createStudy(studyData: any): Observable<any> {
  return this.http.post(`${this.apiUrl}/api/createStudy`, studyData);
}

// Field Urls
deleteFields(id: any, name: string): Observable<any> {
  return this.http.delete(`${this.apiUrl}/api/deleteField/${id}/${name}`)
}

deleteField(id: string, field_id: string): Observable<any> {
  const headers = this.buildHeaders();
  const queryParams = new URLSearchParams()
  queryParams.set('field_id', field_id);
  queryParams.set('id', id);
  return this.http.post(`${this.apiUrl}/api/deleteField?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getStudiesCreatedByUser(userId: number): Observable<any> {
  const queryParams = new URLSearchParams({userId: userId.toString()}).toString();
  return this.http.get(`${this.apiUrl}/api/getUserCreatedStudies?${queryParams}`).pipe(
    catchError((error) => this.handleError(error))
  )
}

getStudyData(page: number, limit: number, locationFilter: string, subjectFilter: string, formFilter: string, fieldFilter: string, studyId: number): Observable<any> {
  const headers = this.buildHeaders();
  const queryParams = new URLSearchParams({page: page.toString(), limit: limit.toString(), locationFilter, subjectFilter, formFilter, fieldFilter, studyId: studyId.toString()}).toString();
  return this.http.get(`${this.apiUrl}/api/getStudyData?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getStudyQueries(
  studyId: string | number,
  params?: { subjectFilter?: string; locationFilter?: string; page?: number; limit?: number }
): Observable<any> {
  const headers = this.buildHeaders();
  const q = new URLSearchParams();
  q.set('studyId', String(studyId));
  if (params?.subjectFilter != null && params.subjectFilter !== '') q.set('subjectFilter', params.subjectFilter);
  if (params?.locationFilter != null && params.locationFilter !== '') q.set('locationFilter', params.locationFilter);
  if (params?.page != null) q.set('page', String(params.page));
  if (params?.limit != null) q.set('limit', String(params.limit));
  return this.http.get(`${this.apiUrl}/api/getStudyQueries?${q.toString()}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

closeStudyQueriesBulk(payload: { studyId: string | number; queryIds: (string | number)[] }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/closeStudyQueriesBulk`, payload, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getTemplateTableColumns(fieldId: string | number): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.get(`${this.apiUrl}/api/template/table-columns/${fieldId}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Template Urls
gettemplates(): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.get(`${this.apiUrl}/api/getEcrfTemplates`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Get locked templates for study creation
getLockedTemplates(id: string): Observable<Template[]> {
  return this.http.get<Template[]>(`${this.apiUrl}/api/locked-templates`, { params: { id } }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getTemplateId(name: string): Observable<any> {
  const headers = this.buildHeaders();
  const queryParams = new URLSearchParams({name: name}).toString(); 
  return this.http.get(`${this.apiUrl}/api/getEcrfTemplateId?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getTemplateData(id: string): Observable<any> {
  const headers = this.buildHeaders();
  const queryParams = new URLSearchParams({id: id}).toString(); 
  return this.http.get(`${this.apiUrl}/api/getEcrfTemplateData?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

saveTemplates(template: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/setEcrfTemplates`, template, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

createForm(id: string, folder: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/createForm`, {id, folder},{ headers }).pipe(
    catchError((error) => this.handleError(error))
  )
}

editForm(id: string, data: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/editForm`, {id, data}, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

deleteForm(id: string, data: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/deleteForm`, {id, data}, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

createField(id: string, forms: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/createField`, { id, forms }, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

editField(id: string, forms: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/editField`, { id, forms }, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

updateTablecolumns(id: string, forms: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/updateTableColumns`, { id, forms }, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

deleteTableColumn(id: string, column: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/deleteTableColumn`, { id, column }, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

submitFields(payload: { template_id: string, form_id: string, fields: Array<{id: string, name: string}> }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/submitFields`, payload, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

saveFolder(id: string,folder: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/createFolder`, {id, folder}, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

editFolder(id: string, folder: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/editFolder`, {id, folder}, {headers}).pipe(
    catchError((error) => this.handleError(error))
  )
}

deleteFolder(id: string, folder: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/deleteFolder`, {id, folder}, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

updateTemplateLockStatus(updateData: any): Observable<any> {
  const headers = this.buildHeaders(); 
  return this.http.put(`${this.apiUrl}/api/updateTemplateLockStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Freeze/Unfreeze/Lock template *items* (folders/forms/fields) - mirrors site-list pattern
updateTemplateItemFreezeStatus(updateData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.put(`${this.apiUrl}/api/updateTemplateItemFreezeStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

updateTemplateItemLockStatus(updateData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.put(`${this.apiUrl}/api/updateTemplateItemLockStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Alternative method using POST instead of PUT
updateTemplateLockStatusPost(updateData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/updateTemplateLockStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

/**
 * Update study freeze (and lock) via locked_data (POST /api/lock-field).
 * Uses the same lockField as study lock; sets both is_freezed and is_locked.
 * updateData: { study_id, is_frozen, is_locked, locked_by, reason? }
 */
updateStudyFreezeStatus(updateData: { study_id: string | number; is_frozen: boolean; is_locked: number | boolean; locked_by: string; reason?: string }): Observable<any> {
  const body = {
    locked_data_id: updateData.study_id,
    data_type: 'study',
    study_id: updateData.study_id,
    locked_by: updateData.locked_by,
    is_freezed: updateData.is_frozen ? 1 : 0,
    is_locked: updateData.is_locked ? 1 : 0
  };
  return this.lockField(body);
}

updateStudyLockStatus(updateData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.put(`${this.apiUrl}/api/updateStudyLockStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

/** Lock via locked_data. Body: { locked_data_id, data_type, locked_by, is_freezed?, is_locked?, study_id?, subject_id? } */
lockField(body: { locked_data_id: string | string[] | number; data_type: string; locked_by: string; is_freezed?: number | boolean; is_locked?: number | boolean; study_id?: string | number; subject_id?: string | number }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/lock-field`, body, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

/**
 * Fetch freeze/lock status from locked_data. Body: { locked_data_id, data_type? }
 * Returns { data: Array<{ locked_data_id, is_freezed, is_locked, data_type, locked_by, locked_at }> }
 */
fetchLockedFields(body: { locked_data_id: string | string[] | number | number[]; data_type?: string; study_id?: string | number, subject_id?: string | number[] }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/fetch-locked-fields`, body, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

/**
 * Fetch locked_data rows by study_id, subject_id, or field_id.
 * Body: { study_id?, subject_id?, field_id?, field_ids? }
 */
fetchLockedDataByContext(body: { study_id?: string | number; subject_id?: string | number | (string | number)[]; field_id?: string | number | (string | number)[]; field_ids?: (string | number)[] }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/fetch-locked-data-context`, body, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

/**
 * Update subject freeze (and lock) via locked_data (POST /api/lock-field).
 * updateData: { subject_id, is_frozen, is_locked, locked_by, study_id?, reason? }
 */
updateSubjectFreezeStatus(updateData: { locked_data_id: string | number, subject_id: string | number; is_frozen: boolean; is_locked: number | boolean; locked_by: string; study_id?: string | number; reason?: string }): Observable<any> {
  const body = {
    locked_data_id: updateData.locked_data_id,
    subject_id: updateData.subject_id,
    data_type: 'subject',
    locked_by: updateData.locked_by,
    is_freezed: updateData.is_frozen ? 1 : 0,
    is_locked: updateData.is_locked ? 1 : 0,
    ...(updateData.study_id != null && { study_id: updateData.study_id })
  };
  return this.lockField(body);
}

/**
 * Update subject lock via locked_data (POST /api/lock-field), same as freeze.
 * updateData: { subject_id, is_locked, locked_by, study_id?, reason? }
 */
updateSubjectLockStatus(updateData: { locked_data_id: string | number, subject_id: string | number; is_locked: number | boolean; locked_by: string; study_id?: string | number; reason?: string }): Observable<any> {
  const body = {
    locked_data_id: updateData.locked_data_id,
    subject_id: updateData.subject_id,
    study_id: updateData.study_id,
    data_type: 'subject',
    locked_by: updateData.locked_by,
    is_freezed: 0,
    is_locked: updateData.is_locked ? 1 : 0,
    ...(updateData.study_id != null && { study_id: updateData.study_id })
  };
  return this.lockField(body);
}

deleteTemplate(id: string): Observable<any> {
  const headers = this.buildHeaders();
  const queryParams = new URLSearchParams({id: id}).toString(); 
  return this.http.delete(`${this.apiUrl}/api/deleteEcrfTemplate?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}





// getAllStudies(page: number, limit: number, name: string = '', assigned_by: string = '', is_active: string = '', status: string = ''): Observable<any> {
//   const token = this.cookieService.get('token'); // Get the token from cookies
//   const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  
//   // Append filters to the query string
//   const queryParams = new URLSearchParams({
//     page: page.toString(),
//     limit: limit.toString(),
//     name,  // Study name filter
//     assigned_by,  // Assigned by filter
//     is_active,    // Active status filter
//     status
//   }).toString();
  
//   return this.http.get(`${this.url}/api/getAllStudies?${queryParams}`, { headers }).pipe(
//     catchError((error) => this.handleError(error))
//   );
// }

getAllStudies(
  userId: string,
  page: number, 
  limit: number, 
  name: string = '', 
  assigned_by: string = '', 
  is_active: string = '', // <- This should map to the is_active filter, not status
  status: string = '', 
  site_location: string = '' // Add site_location parameter
): Observable<any> {
  const token = this.cookieService.get('token'); // Get the token from cookies
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  // Append filters to the query string
  const queryParams = new URLSearchParams({
    userId,
    page: page.toString(),
    limit: limit.toString(),
    name,  // Study name filter
    assigned_by,  // Assigned by filter
    is_active,    // Active status filter (was statusFilter in UI)
    status,       // Status filter
    site_location // Site location filter
  }).toString();

  return this.http.get(`${this.url}/api/getAllStudies?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );


}



// getAllStudies(userId: string, page: number, limit: number, name: string = '', assigned_by: string = '', is_active: string = '', status: string = ''): Observable<any> {
//   const token = this.cookieService.get('token'); // Get the token from cookies
//   const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  
//   // Append filters to the query string
//   const queryParams = new URLSearchParams({
//     userId,
//     page: page.toString(),
//     limit: limit.toString(),
//     name,  // Study name filter
//     assigned_by,  // Assigned by filter
//     is_active,    // Active status filter
//     status
//   }).toString();
  
//   return this.http.get(`${this.url}/api/getAllStudies?${queryParams}`, { headers }).pipe(
//     catchError((error) => this.handleError(error))
//   );
// }









getStudies(): Observable<any> {
  return this.http.get(`${this.apiUrl}/api/studies`);
}



addSubject(studyCrcId: string, site_location: string, subjectData: { studyCrcId: string, subjectId: string, participantId?: string, subjectInitial?: string }): Observable<any> {
  // Get userId from cookieService
  const userData = this.cookieService.get('userData');
  const userId = userData ? JSON.parse(userData).id : null;
  
  if (!userId) {
    throw new Error('User ID not found in cookies');
  }
  
  // Try the current endpoint first
  return this.http.post(`${this.apiUrl}/api/subjects/${studyCrcId}/${site_location}/${userId}`, subjectData);
  
}

// Alternative method in case the backend expects a different endpoint
addSubjectAlternative(studyCrcId: string, subjectData: { studyCrcId: string, subjectId: string }): Observable<any> {
  // Alternative endpoint - uncomment if the above doesn't work
  // return this.http.post(`${this.apiUrl}/api/subjects`, subjectData);
  return this.http.post(`${this.apiUrl}/api/subjects/${studyCrcId}`, subjectData);
}

deleteSubject(subjectCode: string, studyCrcId: string): Observable<any> {
  return this.http.delete(`${this.apiUrl}/api/deleteSubject/${subjectCode}`, {
    body: { study_crc_id: studyCrcId }
  });
}

deleteSubjectFromStudy(subjectId: string): Observable<any> {
  return this.http.delete(`${this.apiUrl}/api/deleteSubjectFromStudy/${subjectId}`);
}

updateSubject(
  studyCrcId: string,
  site_location: string,
  currentSubjectId: string,
  updateData: { subjectId: string; participantId?: string; subjectInitial?: string }
): Observable<any> {
  const token = this.cookieService.get('token');
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);

  // Backend route: PUT /api/subjects/:studyCrcId/:site_location/:currentSubjectId
  return this.http.put(
    `${this.apiUrl}/api/subjects/${studyCrcId}/${site_location}/${currentSubjectId}`,
    updateData,
    { headers }
  );
}

getSubjectIds(studyCrcId: string, site_location: string): Observable<any> {
  const queryParams = new URLSearchParams({
    studyCrcId: studyCrcId,
    site_location: site_location
  }).toString();
  return this.http.get(`${this.apiUrl}/api/subjectids?${queryParams}`)
}





getAllCRCStudies(
  userId: string, 
  designation: string, 
  page: number, 
  limit: number, 
  crcName?: string, 
  studyName?: string, 
  location?: string, 
  assignedBy?: string
  
  
  ): Observable<any> {
  const token = this.cookieService.get('token'); // Get the token from cookies
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  
  // Append filters to the query string
  const queryParams = new URLSearchParams({
    userId, 
    designation,
    page: page.toString(),
    limit: limit.toString(),
    crcName: crcName || '', 
    studyName: studyName || '', 
    location: location || '', 
    assignedBy: assignedBy || ''
  }).toString();
  
  return this.http.get(`${this.url}/api/getAllCRCStudies?${queryParams}`, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}


  // Modified method to fetch user details by ID
  getEditUserById(userId: any): Observable<any> {
    const token = this.cookieService.get('token'); // Get the token from cookies
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get(`${this.apiUrl}/api/getUserById/${userId}`,{ headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }


  
  

  // Method to fetch designations from the backend
  getDesignations(): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/api/designations`)
      .pipe(catchError((error) => this.handleError(error)));
  }
  
  // Add method to fetch cities
getCities(): Observable<string[]> {
  return this.http.get<string[]>(`${this.apiUrl}/api/cities`)
    .pipe(catchError((error) => this.handleError(error)));
}

// // Method to fetch site locations from the backend
// getSiteLocations(): Observable<string[]> {
//   return this.http.get<string[]>(`${this.apiUrl}/api/site_locations`)
//     .pipe(catchError((error) => this.handleError(error)));
// }

getStates(): Observable<string[]> {
  return this.http.get<string[]>(`${this.apiUrl}/api/states`)
    .pipe(catchError((error) => this.handleError(error)));
}



  // my personal code api code starts here


  register(user: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/register`, user);
  };

  // Submit registration form data
  submitRegistration(formData: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/api/submit-registration`, formData).pipe(
      catchError((error) => this.handleError(error))
    );
  }


  requestOtp(email: string): Observable<any> {
      return this.http.post(`${this.apiUrl}/api/requestOtp`, { email }).pipe(
        catchError((error) => this.handleError(error))
      );

    }

    validateOtp(email: string, otp: string): Observable<any> {
      return this.http.post(`${this.apiUrl}/api/validateOtp`, { email, otp }).pipe(
        catchError((error) => this.handleError(error))
      );
    }

   

    reSendOtp(email: string): Observable<any> {
      return this.http.post(`${this.url}/api/reSendOtp`, { email }).pipe(
        catchError((error) => this.handleError(error))
      );

    }




    // mt extra  code here


  // my personal code api ends here

  private handleError(error: HttpErrorResponse) {
    console.log('Full error object:', error);
    // console.log('Status:', error.status);
    if (error.status === 401) {
      this.commonService.deleteAllCookies();
      this.router.navigate(['/login']);
      return throwError(() => Error("Authentication Failed"));
    } else {
      return throwError(error);
    }
  }
  
  getUserById(userId: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/api/viewuser/${userId}`).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Get user notifications
  getUserNotifications(userId: string): Observable<any> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
    return this.http.get(`${this.apiUrl}/api/notifications/${userId}`, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Mark notification as read
  markNotificationAsRead(notificationId: number): Observable<any> {
    const token = this.cookieService.get('token');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    });
    // Try endpoint with /read first, if backend uses different endpoint, update accordingly
    return this.http.put(`${this.apiUrl}/api/notifications/${notificationId}/read`, { is_read: 1 }, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }
  updateStatus(userId: string, status: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.cookieService.get('token')}` // Add authorization token if required
    });
  
    const body = { status: status }; // Ensure the body matches the backend's expectations
  
    return this.http.put(`${this.apiUrl}/api/user/status/${userId}`, body, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

  // Update access status
  updateAccessStatus(accessId: string, status: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.cookieService.get('token')}`
    });
  
    const body = { status: status };
  
    return this.http.put(`${this.apiUrl}/api/access/status/${accessId}`, body, { headers }).pipe(
      catchError((error) => this.handleError(error))
    );
  }

buildHeaders(existingHeaders?: HttpHeaders): HttpHeaders {
  // Get the token from cookies
  const token = this.cookieService.get('token');
  const userData = this.commonService.getUserData();
  // Initialize with existing headers or create a new HttpHeaders object
  let headers:HttpHeaders = existingHeaders || new HttpHeaders();
  // console.log(userData);
  if(userData != null) {
    // console.log(userData.id);
    headers = headers.set('User-Id', userData.id.toString());
  }
  // Add the Authorization header
  if (token) {
    headers = headers.set('Authorization', `Bearer ${token}`);
  }

  // Add any other common headers here
  headers = headers.set('Content-Type', 'application/json');

  return headers;
}


// Fetch data based on `study_crc_id` and `id`
getStudyMonitoringData(study_crc_id: string): Observable<any[]> {
  const params = new HttpParams().set('study_crc_id', study_crc_id);

  return this.http.get<any[]>(`${this.url}/api/getAllStudyCrcMonitoringData`, { params });
}



// Add this method in ApiService
countTotalStudies(): Observable<any> {
  return this.http.get(`${this.url}/api/countTotalStudies`).pipe(
    catchError((error) => this.handleError(error))
  );
}

getStudyCodes(): Observable<string[]> {
  return this.http.get<string[]>(`${this.url}/api/getStudyCodes`).pipe(
    catchError((error) => this.handleError(error))
  );
}

getStudyNames(code: string): Observable<string[]> {
  const params = new HttpParams().set('code', code); // Add the code as a query parameter
  return this.http.get<string[]>(`${this.url}/api/getStudyNames`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Method to fetch dashboard study details
getDashboardStudyDetails(studyCode: string): Observable<any[]> {
  return this.http.get<any[]>(`${this.url}/api/getDashboardStudyDetails/${studyCode}`).pipe(
    catchError(this.handleError)
  );
}

getDashboardbarchart(studyCode: string): Observable<any[]> {
  return this.http.get<any[]>(`${this.url}/api/getDashboardbarchart/${studyCode}`).pipe(
    catchError(this.handleError)
  );
}

getAuditTrail(params: HttpParams): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/api/getAuditTrail`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getSystemAuditTrail(params: HttpParams): Observable<any> {
  const token = this.cookieService.get('token');
  const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`);
  return this.http.get<any>(`${this.apiUrl}/api/getSystemAuditTrail`, { params, headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getFormsForStudy(studyId: string): Observable<any> {
  const params = new HttpParams().set('study_id', studyId);
  return this.http.get<any>(`${this.apiUrl}/api/getFormsForStudy`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getSubjectsForStudy(studyId: string): Observable<any> {
  const params = new HttpParams().set('study_id', studyId);
  return this.http.get<any>(`${this.apiUrl}/api/getSubjectsForStudy`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

insertFormData(formData: any): Observable<any> {
  return this.http.post<any>(`${this.url}/api/insert-form`, formData).pipe(
      catchError(this.handleError)
  );
}
 
submitQueryData(payload: any): Observable<any> {
  return this.http.post(`${this.url}/api/insert-query`, payload).pipe( // Adjust URL as needed
     catchError(this.handleError)
  );
}
getFormData(studyId: string, subjectId: string, folderName: string, formName: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/api/formdata/${studyId}/${subjectId}/${folderName}/${formName}`);
}

// Study Template API Methods
submitTemplateFormData(formData: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/api/template/submit-form`, formData).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Update fixed-rows-table statement values in ecrf_table
updateFixedRowsTableStatementValues(data: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/api/template/update-fixed-rows-table-values`, data).pipe(
    catchError((error) => this.handleError(error))
  );
}

deleteTableRow(field_id: number, row_index: number, id: number): Observable<any> {
  const params = new HttpParams()
    .set('field_id', field_id)
    .set('row_index', row_index)
    .set('id', id);
  return this.http.delete<any>(`${this.apiUrl}/api/template/delete-table-row`, {params}).pipe(
    catchError((error) => this.handleError(error))
  )
} 

getTemplateFormData(studyId: string, subjectId: string, folderName: string, formName: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/api/template/formdata/${studyId}/${subjectId}/${folderName}/${formName}`).pipe(
    catchError((error) => this.handleError(error))
  );
}

getTemplateFormDataByQuery(studyId: string, subjectId: string, formId: string): Observable<any> {
  const params = new HttpParams()
    .set('study_id', studyId)
    .set('subject_id', subjectId)
    .set('form_id', formId);
    
  return this.http.get<any>(`${this.apiUrl}/api/template/get-form-data`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getTemplateHistoryByQuery(studyId: string, subjectId: string, formId: string, fieldId: string, rowId?: string): Observable<any> {
  const params = new HttpParams()
    .set('study_id', studyId)
    .set('subject_id', subjectId)
    .set('form_id', formId)
    .set('field_id', fieldId)
    .set('row_id', rowId || 'undefined');
    
  return this.http.get<any>(`${this.apiUrl}/api/template/fetch-history`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

submitTemplateQuery(queryData: any): Observable<any> {
  return this.http.post<any>(`${this.apiUrl}/api/template/submit-query`, queryData).pipe(
    catchError((error) => this.handleError(error)) 
  );
}

getTemplateQueryHistory(studyId: string, subjectId: string,formName: string, fieldName: string, rowId?: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/api/template/query-history/${studyId}/${subjectId}/${formName}/${fieldName}/${rowId}`).pipe(
    catchError((error) => this.handleError(error))
  );
}

closeTemplateQuery(queryData: any): Observable<any> {
  // Send { queryId: <number> } as body
  return this.http.post<any>(`${this.apiUrl}/api/template/close-query`, queryData).pipe(
    catchError((error) => this.handleError(error))
  );
}

fetchReviewData(studyId: string, subjectId: string, formId: string, fieldId: string): Observable<any> {
  const headers = this.buildHeaders();
  const params = {
    studyId,
    subjectId,
    formId,
    fieldId
  };
  return this.http.get<any>(`${this.apiUrl}/api/template/fetch-review-data`, { headers, params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

updateReviewStatus(reviewData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post<any>(`${this.apiUrl}/api/template/update-review-status`, reviewData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}



getTemplateFieldHistory(studyId: string, subjectId: string, folderName: string, formName: string, fieldName: string): Observable<any> {
  return this.http.get<any>(`${this.apiUrl}/api/template/field-history/${studyId}/${subjectId}/${folderName}/${formName}/${fieldName}`).pipe(
    catchError((error) => this.handleError(error))
  );
}

// Note: Field locking is now handled entirely in the frontend

// Table functionality will be recreated from scratch

getInsertHistoryData(
  studyId: string,
  subjectId: string,
  folderName: string,
  formName: string | null,
  fieldName: string
): Observable<any> {
  return this.http.get<any>(
    `${this.apiUrl}/api/insert-history/${studyId}/${subjectId}/${folderName}/${formName}/${fieldName}`
  );
}

getQueryHistoryData(
  studyId: string,
  subjectId: string,
  folderName: string,
  formName: string | null,
  fieldName: string
): Observable<any> {
  return this.http.get<any>(
    `${this.apiUrl}/api/query-history/${studyId}/${subjectId}/${folderName}/${formName}/${fieldName}`
  );
}

// Dynamic form configuration methods
getDynamicFormConfig(studyName: string, folderName: string, formName: string): Observable<any> {
  const params = new HttpParams()
    .set('studyName', studyName)
    .set('folderName', folderName)
    .set('formName', formName);
  
  return this.http.get<any>(`${this.url}/api/dynamic-form-config`, { params }).pipe(
    catchError((error) => this.handleError(error))
  );
}

saveDynamicFormConfig(studyName: string, folderName: string, formName: string, config: any): Observable<any> {
  const payload = {
    studyName,
    folderName,
    formName,
    config
  };
  
  return this.http.post<any>(`${this.url}/api/dynamic-form-config`, payload).pipe(
    catchError((error) => this.handleError(error))
  );
}

getSiteLocations(): Observable<Site[]> {
  return this.http.get<Site[]>(`${this.url}/api/site_locations`);
}

getSites(id: string): Observable<Site[]> {
  return this.http.get<Site[]>(`${this.url}/api/site_list`, { params: { id } });
}

addSite(siteData: any): Observable<any> {
    console.log('Sending payload to API:', siteData); // debug
    return this.http.post(`${this.url}/api/sites`, siteData);
  }


deleteSite(id: string): Observable<any> {
  return this.http.delete(`${this.url}/api/sites/${id}`);
}

updateSite(id: string | number, siteData: any): Observable<any> {
  return this.http.put(`${this.url}/api/sites/${id}`, siteData);
}

updateSiteFreezeStatus(updateData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.put(`${this.url}/api/updateSiteFreezeStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

updateSiteLockStatus(updateData: any): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.put(`${this.url}/api/updateSiteLockStatus`, updateData, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

getLocationMap() {
  return this.http.get<any[]>(`${this.apiUrl}/api/getLocationMap`); // adjust base URL if your API is different
}

updateFolderOrder(templateId: string, folders: Array<{id: string, folder_order: number}>): Observable<any> {
  const url = `${this.url}/api/templates/${templateId}/folders/reorder`;
  return this.http.put(url, { folders }).pipe(
    catchError(error => {
      console.error('Error updating folder order:', error);
      return throwError(error);
    })
  );
}

reorderFields(payload: { template_id: string, form_id: string, fields: Array<{field_id: string, field_order: number}> }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/reorderFields`, payload, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

duplicateFolder(templateId: string, sourceFolderId: string, newFolderName: string): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/duplicateFolder`, {
    templateId,
    sourceFolderId,
    newFolderName
  }, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

duplicateForm(
  templateId: string,
  folderId: string | null,
  sourceFormId: string,
  newFormName: string,
  folderIds?: string[]
): Observable<any> {
  const headers = this.buildHeaders();
  const normalizedFolderIds = Array.isArray(folderIds) ? folderIds : [];
  const payload: any = {
    templateId,
    folderId,
    // Also include explicit key if backend distinguishes source vs targets
    sourceFolderId: folderId,
    // Send both in case backend expects snake_case
    folderIds: normalizedFolderIds,
    folder_ids: normalizedFolderIds,
    sourceFormId,
    newFormName
  };
  console.log('[duplicateForm] request payload:', payload);
  return this.http.post(`${this.apiUrl}/api/duplicateForm`, payload, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

duplicateField(templateId: string, formId: string, sourceFieldId: string, newFieldTitle: string): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/duplicateField`, {
    templateId,
    formId,
    sourceFieldId,
    newFieldTitle
  }, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

updateBulkOrder(payload: { template_id: string, folder: Array<{ folder_id: string, folder_order: number, forms: Array<{ form_id: string, form_order: number }> }> }): Observable<any> {
  const headers = this.buildHeaders();
  return this.http.post(`${this.apiUrl}/api/updateTemplateOrder`, payload, { headers }).pipe(
    catchError((error) => this.handleError(error))
  );
}

}